// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__188Ju","file":"styles_file__2yz-G"};